{
  "key": "bay-rd-beach-shack",
  "title": "Bay Rd beach shack",
  "suburb": "Coolamon Bay",
  "locationGroup": "backyards",
  "grassType": "couch",
  "cellM": 0.5,
  "w": 22,
  "h": 46,
  "rows": [
    "eeeeeeeeeeeeeeeeeeeeee",
    "eoogggggggbbbbggggggge",
    "eoogGGGGggbbbbggggggge",
    "ebbGGGGGGgggggggggggge",
    "ebbbGGGGGGgggggggggbbe",
    "ebbbbGGGGGgggggogggbbe",
    "ebbbbGGGGggggggggggbbe",
    "ebbbGGGGgggggggggggbbe",
    "ebbggggggggggggGGggbbe",
    "egggggggggggggGGGGgbbe",
    "epppppppppppgGGGGGGbbe",
    "epppppppppppgGGGGGGbbe",
    "e...........gGGGGGGbbe",
    "e...........gGGGGGGbbe",
    "e...........ggGGGGgbbe",
    "e...........gggGGgggge",
    "e...........ggggggggge",
    "e...........ggggggggge",
    "e...........ggggggggge",
    "e...........ggggggggge",
    "e...........ggggggggge",
    "e...........ggggggggge",
    "e...........ggpppppppe",
    "e...........ggpppppppe",
    "e...........ggpooooppe",
    "e...........ggpooooppe",
    "ebbgggggggggggpooooppe",
    "ebbgggggggggggpooooppe",
    "ebbggGGGogggggpooooppe",
    "ebbgGGGGGGggggpooooppe",
    "ebbgGGGGGGggggpooooppe",
    "ebbggGGGGgogggpooooppe",
    "ebbgggggggggggpooooppe",
    "ebbgggggggggggpooooppe",
    "ebbgggggggggggpppppppe",
    "ebbggggggggggoppppppoe",
    "pppppppppppppppppppppp",
    "pppppppppppppppppppppp",
    "gggggggggggggggggggggg",
    "gggggggggggggggggggggg",
    "gggggggggggggggggggggg",
    "gggggggggggggggggggggg",
    "pppppppppppppppppppppp",
    "......................",
    "......................",
    "......................"
  ],
  "zoneRows": [
    "......................",
    "......................",
    "......................",
    "......................",
    "......................",
    "......................",
    "......................",
    "......................",
    "......................",
    "......................",
    "......................",
    "......................",
    "......................",
    "......................",
    "......................",
    "......................",
    "......................",
    "......................",
    "......................",
    "......................",
    "......................",
    "......................",
    "......................",
    "......................",
    "......................",
    "......................",
    "......................",
    "......................",
    "......................",
    "......................",
    "......................",
    "......................",
    "......................",
    "......................",
    "......................",
    "......................",
    "......................",
    "......................",
    "NNNNNNNNNNNNNNNNNNNNNN",
    "NNNNNNNNNNNNNNNNNNNNNN",
    "NNNNNNNNNNNNNNNNNNNNNN",
    "NNNNNNNNNNNNNNNNNNNNNN",
    "......................",
    "......................",
    "......................",
    "......................"
  ],
  "zones": [
    {"id":"nature-strip","rangeMm":[50,70]}
  ],
  "rangeMm": [40,60],
  "startLengthMm": [120,180],
  "props": [
    {"id":"house","kind":"house","x":3.25,"y":9.5,"w":5.5,"h":7,"solid":true,"penalty":false},
    {"id":"caravan-1","kind":"caravan","x":8.6,"y":14.6,"w":2.3,"h":5.2,"solid":true},
    {"id":"water-tank-1","kind":"water-tank","x":0.9,"y":1.1,"r":0.55,"solid":true},
    {"id":"hills-hoist-1","kind":"hills-hoist","x":7.9,"y":2.8,"r":0.2,"solid":true,"canopyR":2.2},
    {"id":"rock-1","kind":"rock","x":4.1,"y":14.4,"r":0.35,"solid":true},
    {"id":"rock-2","kind":"rock","x":5.1,"y":15.7,"r":0.3,"solid":true},
    {"id":"rock-3","kind":"rock","x":9.3,"y":3.9,"r":0.25,"solid":false},
    {"id":"tap-1","kind":"tap","x":6.1,"y":5.2,"r":0.1,"solid":false},
    {"id":"wheelie-bin-1","kind":"wheelie-bin","x":10.3,"y":17.6,"w":0.6,"h":0.6,"solid":true},
    {"id":"letterbox-1","kind":"letterbox","x":6.6,"y":17.6,"w":0.4,"h":0.3,"solid":true},
    {"id":"stone-edging-1","kind":"stone-edging","x":1.6,"y":15.5,"w":0.15,"h":4,"solid":false}
  ],
  "spawn": {"x":8.75,"y":17.75,"heading":-1.5707963267948966},
  "utePark": {"x":8.75,"y":18.25,"heading":-1.5707963267948966},
  "weedFraction": 0.35,
  "leaves": {"count":[120,180]},
  "camera": {"fit":"contain","allowLandscape":false},
  "mutations": ["above-ground-pool","bin-night","bindii","ibis","lost-ball","hot-day"]
}
